import { Component, inject } from '@angular/core';
import { Erzeugungsanlage } from '../../domain/model/erzeugungsanlage';
import { ErzeugungsanlageService } from '../../service/erzeugungsanlage/erzeugungsanlage.service';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '../../service/common/routing/routing.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { map } from 'rxjs/operators';
import {
    ErzeugungsanlageDetailSummenerzeugerComponent,
} from '../erzeugungsanlage-detail-summenerzeuger/erzeugungsanlage-detail-summenerzeuger.component';
import { Anlagentyp } from '../../domain/model/anlagentyp';
import { Observable } from 'rxjs/internal/Observable';
import { AnlagentypService } from '../../service/anlagentyp/anlagentyp.service';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { of } from 'rxjs';

@Component({
    selector: 'tnb-erzeugungsanlage-detail',
    templateUrl: './erzeugungsanlage-detail.component.html',
    styleUrls: [
        './erzeugungsanlage-detail.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageDetailComponent {
    private erzeugungsanlageService = inject(ErzeugungsanlageService);
    private anlagentypService = inject(AnlagentypService);
    private authService = inject(AuthenticationService);
    routingService = inject(RoutingService);
    private activeRoute = inject(ActivatedRoute);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);

    public erzeugungsanlage$: Observable<Erzeugungsanlage>;
    public stadtwerkeId: string = null;
    public createNewMode = false;
    public readonly$: Observable<boolean>;
    public anlagentypen: Observable<Anlagentyp[]>;

    constructor() {

        const westnetzId = this.activeRoute.snapshot.queryParams['erzeugungsanlage'];
        this.createNewMode = this.activeRoute.snapshot.queryParams['createnew'] === 'true';
        this.stadtwerkeId = this.teilgebietSelectionService.getSelectedStadtwerkeId();

        this.anlagentypen = this.anlagentypService.getAnlagentypen()
            .pipe(map(anlagentypen => {
                anlagentypen.sort((a, b) => {
                    return a.nummer < b.nummer ? -1 : 1;
                });
                return anlagentypen;
            }));

        this.readonly$ = this.authService.user$.pipe(map(u => !!u && u.netzbetreiberType === 'WESTNETZ'));

        if (this.createNewMode) {
            this.erzeugungsanlage$ = of(ErzeugungsanlageDetailSummenerzeugerComponent.createNewSummenerzeuger());
        } else {
            this.getErzeugungsanlage(westnetzId);
        }
    }

    private getErzeugungsanlage(westnetzId: string) {
        this.erzeugungsanlage$ = this.erzeugungsanlageService.getErzeugungsanlage(westnetzId);
    }
}

